import * as THREE from 'three'

export default class Core {
  constructor() {
    this.camera = new THREE.PerspectiveCamera()
    this.renderer = new THREE.WebGLRenderer()
    this.scene = new THREE.Scene()
    this.initScene()
    this.initRenderer()
    this.initCamera()
  }

  camera: THREE.PerspectiveCamera
  scene: THREE.Scene
  renderer: THREE.Renderer
  sunLight = new THREE.PointLight(0xffffff, 0.5)
  moonLight = new THREE.PointLight(0xb8c7ff, 0.2)
  reflectionLight = new THREE.AmbientLight(0x404040)
  dayStart = performance.now()

  initCamera = () => {
    this.camera.fov = 50
    this.camera.aspect = window.innerWidth / window.innerHeight
    this.camera.near = 0.01
    this.camera.far = 500
    this.camera.updateProjectionMatrix()
    this.camera.position.set(8, 50, 8)

    this.camera.lookAt(100, 30, 100)

    window.addEventListener('resize', () => {
      this.camera.aspect = window.innerWidth / window.innerHeight
      this.camera.updateProjectionMatrix()
    })
  }

  initScene = () => {
    this.scene = new THREE.Scene()
    const backgroundColor = 0x87ceeb

    this.scene.fog = new THREE.Fog(backgroundColor, 1, 96)
    this.scene.background = new THREE.Color(backgroundColor)

    this.sunLight.position.set(500, 500, 500)
    this.scene.add(this.sunLight)

    this.moonLight.position.set(-500, 500, -500)
    this.scene.add(this.moonLight)

    this.scene.add(this.reflectionLight)
  }

  initRenderer = () => {
    this.renderer.setSize(window.innerWidth, window.innerHeight)
    document.body.appendChild(this.renderer.domElement)

    window.addEventListener('resize', () => {
      this.renderer.setSize(window.innerWidth, window.innerHeight)
    })
  }

  // jump to noon / midnight in the 90s day cycle
  toggleDayNight = () => {
    const phase = ((performance.now() - this.dayStart) / 90000) % 1
    const isDay = Math.sin(phase * Math.PI * 2) > 0
    this.dayStart = performance.now() - (isDay ? 0.75 : 0.25) * 90000
  }

  update = () => {
    const phase = ((performance.now() - this.dayStart) / 90000) % 1
    const daylight = Math.max(0.18, Math.sin(phase * Math.PI * 2) * 0.5 + 0.5)
    const sky = new THREE.Color(0x87ceeb).lerp(
      new THREE.Color(0x101528),
      1 - daylight
    )
    this.scene.background = sky
    this.scene.fog = new THREE.Fog(sky, 1, 96)
    this.sunLight.intensity = 0.15 + daylight * 0.55
    this.moonLight.intensity = 0.12 + (1 - daylight) * 0.25
    this.reflectionLight.intensity = 0.35 + daylight * 0.35
  }
}
